import React from "react";
import { Section, Container } from "./Elements/Section";
import { Stars } from "lucide-react";
import { COLOR_ACCENT } from "../config/Constants";

export const Footer = () => {
  return (
    <Section id="footer">
      <footer className="border-t border-gray-200 py-10">
        <Container>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-600">
            <div className="flex items-center gap-2 text-gray-800 font-semibold">
              <Stars
                className="w-5 h-5 text-indigo-600"
                style={{ color: COLOR_ACCENT }}
              />{" "}
              SKYENCE
            </div>
            <div className="flex items-center gap-5">
              <a href="#services" className="hover:text-indigo-700">
                Services
              </a>
              <a href="#work" className="hover:text-indigo-700">
                Work
              </a>
              <a href="#contact" className="hover:text-indigo-700">
                Contact
              </a>
            </div>
            <div className="text-gray-500">
              © {new Date().getFullYear()} Skyence Tech. All rights reserved.
            </div>
          </div>
        </Container>
      </footer>
    </Section>
  );
};
